import { JourneyKind } from 'interfaces/journey';

const key = (kind: JourneyKind) => `journeys.lastDraft.${kind}`;

export const rememberLastDraft = (kind: JourneyKind, journeyId: string) => {
  try {
    localStorage.setItem(key(kind), journeyId);
  } catch {}
};

export const lastDraft = (kind: JourneyKind): string | null => {
  try {
    return localStorage.getItem(key(kind));
  } catch {
    return null;
  }
};

export const forgetLastDraft = (kind: JourneyKind) => {
  try {
    localStorage.removeItem(key(kind));
  } catch {}
};

export const highlightMenuItem = (menuKey: string) => {
  try {
    const item = document.querySelector<HTMLElement>(
      `li[data-menu-id$="-${menuKey}"]`,
    );
    item?.click();
  } catch {}
};
